import { COMMON_FOODS, type FoodDatabaseItem } from './foodDatabase';

/** Sin query devuelve el catalogo completo (util para listar opciones antes de escribir). */
export function searchFoods(query: string): FoodDatabaseItem[] {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return COMMON_FOODS;
  return COMMON_FOODS.filter((food) => food.name.toLowerCase().includes(normalized));
}

export interface ScaledMacros {
  calories: number;
  protein: number;
  carbs: number;
  fat: number;
  fiber: number;
  sodium: number;
  sugar: number;
}

function round1(value: number): number {
  return Math.round(value * 10) / 10;
}

/** Escala los macros de un alimento (definidos por 100g) a la cantidad real registrada. */
export function scaleFoodToGrams(food: FoodDatabaseItem, grams: number): ScaledMacros {
  const factor = Math.max(grams, 0) / 100;
  return {
    calories: Math.round(food.caloriesPer100g * factor),
    protein: round1(food.proteinPer100g * factor),
    carbs: round1(food.carbsPer100g * factor),
    fat: round1(food.fatPer100g * factor),
    fiber: round1(food.fiberPer100g * factor),
    sodium: Math.round(food.sodiumPer100gMg * factor),
    sugar: round1(food.sugarPer100g * factor),
  };
}
